/*
 * Shows the back-in-stock form only while the selected variant is
 * unavailable.
 *
 * Rather than hooking Dawn's internal pub/sub, this watches Dawn's own
 * rendered output: the add-to-cart button, which Dawn re-renders and
 * disables whenever the chosen variant is sold out. That keeps it
 * working regardless of how Dawn wires its variant picker internally.
 */
(function () {
  class NotifyRestock extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form') || document;
      this.variantField = this.querySelector('[data-notify-variant]');

      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      } catch (error) {
        this.variants = [];
      }

      // A submitted form reloads the page showing the confirmation, which
      // must stay visible. Note this does NOT return early: the item is
      // still sold out, so Dawn's disabled buttons must stay hidden too.
      // Returning here was leaving "Sold out" and PayPal back on screen.
      this.justSubmitted = this.querySelector('[data-notify-success]') !== null;

      this.productForm = document.querySelector('product-form form, form[action*="/cart/add"]');
      this.submitButton = document.getElementById('ProductSubmitButton-' + this.dataset.sectionId);

      this.update();

      // Dawn replaces the button's subtree when the variant changes, so
      // watch the surrounding form rather than the button itself.
      const target = this.productForm || document.body;
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(target, { childList: true, subtree: true, attributes: true });
    }

    currentVariant() {
      const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input) return null;
      const id = parseInt(input.value, 10);
      return this.variants.find((variant) => variant.id === id) || null;
    }

    update() {
      // Re-query each time: Dawn swaps this button out on variant change.
      const button =
        document.getElementById('ProductSubmitButton-' + this.dataset.sectionId) || this.submitButton;

      const variant = this.currentVariant();

      // Prefer the variant data; fall back to the button's disabled state
      // when a variant cannot be matched (a product with no variants).
      let soldOut;
      if (variant) {
        soldOut = variant.available === false;
      } else if (button) {
        soldOut = button.disabled === true;
      } else {
        soldOut = false;
      }

      // Keep the confirmation on screen even though the form is gone
      this.hidden = !soldOut && !this.justSubmitted;

      // Take the place of the disabled Add to cart button rather than
      // sitting under it — two controls for one decision reads as a
      // second, competing thing to do.
      this.toggleBuyButtons(soldOut);

      if (variant && this.variantField) {
        this.variantField.value = variant.title;
      }
    }

    toggleBuyButtons(soldOut) {
      // A class on <html> rather than hiding the element directly: Dawn
      // re-renders the buttons on every variant change, which would wipe
      // an inline hidden attribute, and setting one inside the observed
      // subtree would retrigger the observer. A class on an ancestor
      // survives both.
      document.documentElement.classList.toggle('variant-sold-out', soldOut);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('notify-restock')) {
    customElements.define('notify-restock', NotifyRestock);
  }
})();
